import classifiesAsFairBall from "../../classificators/fairBallClassifier.js";
import couldClassifyAsBattedBallEvent from "../../classificators/pitchCall/couldClassifyAsBattedBallEvent.js";
import classifiesAsBattedBallEvent from "../../classificators/plateAppearanceResult/classifiesAsBattedBallEvent.js";
import sessionCouldHaveNewScoringData from "../../classificators/sessionContents/sessionCouldHaveNewScoringData.js";
import gameOnly from "../../classificators/sessionType/gameOnly.js";
import IterableDataProcessor from "../../entities/IterableDataProcessor.js";
import DataSection from "../../enums/DataSection.js";
import PitchData from "../../enums/PitchData.js";
import ResultData from "../../enums/ResultData.js";
import ResultType from "../../enums/ResultType.js";
import ScoringData from "../../enums/ScoringData.js";
import EnumValueProvider from "../../providers/EnumValueProvider.js";
import ContextualFilterBase from "./ContextualFilterBase.js";
import supportedScoringType from "../../classificators/scoringType/supportedScoringType.js";

/**
 * A Batted Ball Event represents any batted ball that produces a result. This includes outs, hits and errors. Any fair ball is a Batted Ball Event. So, too, are foul balls that result in an out or an error.
 * Batted Ball Events are a fundamental part of Statcast data. They are used as the denominator when determining batting metrics such as average Exit Velocity and average Launch Angle. All Batted Ball Events by a given hitter are used to determine these averages.
 * @see https://www.mlb.com/glossary/statcast/batted-ball-event
 */
class ClassifiedAsBattedBallEventFilter extends ContextualFilterBase {
    constructor(customResultsProcessor) {
        if (typeof(customResultsProcessor) !== 'undefined' && !(customResultsProcessor instanceof IterableDataProcessor)) {
            throw new TypeError('customResultsProcessor must be an instance inheriting from IterableDataProcessor class');
        }

        super();

        this.resultsProcessor = customResultsProcessor || new IterableDataProcessor(
            new EnumValueProvider()
        );
    }

    filter(results, session, league) {
        if (!gameOnly(session.sessionType)) {
            // for practice we just classify all hits...
            return this.resultsProcessor.filterData(
                results, [{
                    parameter: ResultData.mapPath(ResultData.Type.key),
                    operator: 'CONTAINS',
                    value: ResultType.Hit.key
                }]
            );
        }
        // games with new scoring goes here
        else if (
            // stat grab +  extended tagging
            sessionCouldHaveNewScoringData(
                session.parameters.SessionContents, session.parameters.SessionSchemaRef
            )
            // only supported scoring types...
            && supportedScoringType(session)
        ) {
            // for new scoring look for specific pitch call and PA result values...
            return this.resultsProcessor.filterData(
                results, [
                    {
                        parameter: ResultData.getDataPath(
                            ScoringData.PitchCall.key, DataSection.Scoring.key
                        ),
                        operator: 'function',
                        value: couldClassifyAsBattedBallEvent
                    },
                    {
                        parameter: ResultData.getDataPath(
                            ScoringData.PlateAppearanceResult.key, DataSection.Scoring.key
                        ),
                        operator: 'function',
                        value: classifiesAsBattedBallEvent
                    }
                ]
            );
        }

        // games with tagging from old BBH goes here
        return this.resultsProcessor.filterData(
            results, [
                {
                    parameter: ResultData.getDataPath(
                        PitchData.Result.key, DataSection.Tagging.key, ResultType.Pitch.key
                    ),
                    operator: 'function',
                    value: classifiesAsFairBall
                }
            ]
        );
    }
}

export default ClassifiedAsBattedBallEventFilter;